export const isLoggedIn = state => state.user !== null
export const user = state => state.user